/**
 * =============================================================================
 * ENTITY TAG STRIP COMPONENT - AI-NATIVE DESIGN SYSTEM
 * =============================================================================
 *
 * A horizontal strip of metadata tags for displaying key attributes alongside
 * an entity name. Reusable across vendors, warehouses, channels, etc.
 *
 * USAGE:
 *   <EntityTagStrip tags={[
 *     { label: 'Country', value: 'India' },
 *     { label: 'Category', value: 'Materials' },
 *     { label: 'Lead Time', value: '14–21 days' },
 *   ]} />
 */

import type { FC } from 'react';
import styles from './EntityTagStrip.module.css';

export interface EntityTag {
    label: string;
    value: string;
}

export interface EntityTagStripProps {
    tags: EntityTag[];
    className?: string;
}

const EntityTagStrip: FC<EntityTagStripProps> = ({ tags, className }) => {
    if (!tags || tags.length === 0) return null;

    return (
        <div className={`${styles.strip} ${className ?? ''}`}>
            {tags.map((tag) => (
                <span key={tag.label} className={styles.tag}>
                    <span className={styles.tagLabel}>{tag.label}</span>
                    <span className={styles.tagSeparator}>:</span>
                    <span className={styles.tagValue}>{tag.value}</span>
                </span>
            ))}
        </div>
    );
};

export default EntityTagStrip;
